import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Bannerfrom from "../components/bannerfrom";
import { Link } from "gatsby";

function Banner(props) {
  return (
    <div className="services_location_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="New Jersey">
                <h1>Website Design and Development Company in New Jersey</h1>
              </div>
              <p className="main_para">
                Developing tailor-made, visually appealing, fast-loading, and
                mobile responsive websites that are user-centric yet assures
                scalability to your presence. From custom website development to
                web apps, we can ideate, design, develop, execute, and launch
                custom websites that are robust, flawless, and secure. TekRevol
                as a top-class web design company in New Jersey can leverage the
                latest website development technologies to create a website for
                you that actually converts, and bring traction to your business
                website.
              </p>
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                {" "}
                Let’s Get Started
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
